import { useCallback } from 'react';
import { useNotifications } from '../providers';

const useCopyLink = () => {
  const { addNotification } = useNotifications();

  const copyLink = useCallback(
    (link) => {
      navigator.clipboard.writeText(link);
      addNotification({
        icon: 'link',
        message: 'Link was copied to clipboard'
      });
    },
    [addNotification]
  );

  return copyLink;
};

export { useCopyLink };
